import React from "react";
import { findFile, getFileType, renderFileController } from "./BlogCarouselMediaHandler";
import { Button } from "../../BP2Components";
import { useIntl } from "react-intl";
import { getImageLink } from "../../../util/getImageLink";

type BlogCarouselVariantProps = {
   item: any;
   value: any;
   openModal: (title: string, description: string) => void;
   elementWidth?: number;
   elementHeight?: number;
};

const getImage = (item) => {
   return getImageLink(item?.[0]?.altUrl ?? item?.[0]?.altUrl1 ?? item?.[0]?.fileUrl);
};

const ThreeItems: React.FC<BlogCarouselVariantProps> = ({ item, value, openModal }) => {
   const image = value.columns?.find((col) => col.options?.techName === value.bannerTitle)?.label;

   const title = value.columns?.find(
      (col) => col.options?.techName === value.singleItemTitleColumn,
   )?.label;

   const description = value.columns?.find(
      (col) => col.options?.techName === value.singleItemTitleColumn,
   )?.label;

   const valueForModal =
      typeof item[value?.singleItemTitleColumn] === "string"
         ? item[value?.singleItemTitleColumn]
         : (item[value?.singleItemTitleColumn]?.value ?? item[title]);

   const modalDescription = item[value?.singleItemDescriptionColumn] ?? item[description];

   const itemTitle =
      (typeof item[value?.singleItemTitleColumn] === "string"
         ? item[value?.singleItemTitleColumn]
         : item[value?.singleItemTitleColumn]?.value) ?? item[title];

   const itemImage = getImage(item[value?.bannerTitle]) ?? getImage(item[image]);

   return (
      <div
         className="custom-slide-item-container"
         onClick={() => openModal(valueForModal, modalDescription)}
      >
         <div className="custom-slide-item-container__image-container">
            <img
               className="blog-carousel-img"
               alt={`file: "${item[value?.bannerTitle]?.[0]?.name}" cannot be fetched`}
               src={itemImage}
            />
         </div>
         <div className="custom-slide-item-container__content-container">
            <div>
               <h6 className="main-title">{itemTitle}</h6>
            </div>
            {/* For now we dont need it but maybe in the future "THEY" will want it back */}
            {/* <div className="sub-title-container">
               <div className="date-container">
                  <span className="material-symbols-outlined">calendar_today</span>
                  <span style={{ marginLeft: "20px", paddingTop: "2px" }}>
                     {typeof item[value?.subtitleColumn] === "string"
                        ? item[value?.subtitleColumn]
                        : item[value?.subtitleColumn]?.value}
                  </span>
               </div>
            </div> */}
         </div>
      </div>
   );
};

const OneBigItem: React.FC<BlogCarouselVariantProps> = ({ item, value, openModal }) => {
   const intl = useIntl();

   const image = value.columns?.find((col) => col.options?.techName === value.bannerTitle)?.label;

   const title = value.columns?.find(
      (col) => col.options?.techName === value.singleItemTitleColumn,
   )?.label;

   const subtitle = value.columns?.find(
      (col) => col.options?.techName === value.subtitleColumn,
   )?.label;

   const description = value.columns?.find(
      (col) => col.options?.techName === value.singleItemDescriptionColumn,
   )?.label;

   const valueForModal =
      (typeof item[value?.singleItemTitleColumn] === "string"
         ? item[value?.singleItemTitleColumn]
         : item[value?.singleItemTitleColumn]?.value) ?? item[title];

   const modalDescription = item[value?.singleItemDescriptionColumn] ?? item[description];

   const itemTitle =
      (typeof item[value?.singleItemTitleColumn] === "string"
         ? item[value?.singleItemTitleColumn]
         : item[value?.singleItemTitleColumn]?.value) ?? item[title];

   const itemSubtitle =
      (typeof item[value?.subtitleColumn] === "string"
         ? item[value?.subtitleColumn]
         : item[value?.subtitleColumn]?.value) ?? item[subtitle];

   const itemImage = getImage(item[value?.bannerTitle]) ?? getImage(item[image]);

   return (
      <div className="custom-slide-one-big-view">
         <img
            className="blog-carousel-img"
            alt={"file: " + `"${item[value?.bannerTitle]?.[0]?.name}"` + " cannot be featched"}
            src={itemImage}
         />
         <div className="blog-carousel-data">
            <h2 className="title">{itemTitle}</h2>
            <div className="subtitle p2">{itemSubtitle}</div>
            <div className="button">
               <Button
                  buttonType="primary"
                  size="large"
                  onClick={() => openModal(valueForModal, modalDescription)}
               >
                  <span className="p1">{intl.formatMessage({ id: "business.readMore" })}</span>
               </Button>
            </div>
         </div>
      </div>
   );
};

const ThreeItemsMultipleDataType: React.FC<BlogCarouselVariantProps> = ({
   item,
   value,
   openModal,
   elementWidth,
}) => {
   const title = value.columns?.find(
      (col) => col.options?.techName === value.singleItemTitleColumn,
   )?.label;

   const description = value.columns?.find(
      (col) => col.options?.techName === value.singleItemDescriptionColumn,
   )?.label;

   const valueForModal =
      typeof item[value?.singleItemTitleColumn] === "string"
         ? item[value?.singleItemTitleColumn]
         : (item[value?.singleItemTitleColumn]?.value ?? item[title]);

   const itemTitle =
      (typeof item[value?.singleItemTitleColumn] === "string"
         ? item[value?.singleItemTitleColumn]
         : item[value?.singleItemTitleColumn]?.value) ?? item[title];

   const modalDescription = item[value?.singleItemDescriptionColumn] ?? item[description];

   if (!elementWidth) return null;

   const elementHeight = (elementWidth * 9) / 16;

   return (
      <div
         className="custom-slide-item-container"
         style={{ width: elementWidth }}
         onClick={() => openModal(valueForModal, modalDescription)}
      >
         <div className="custom-slide-item-container__image-container">
            {renderFileController(
               findFile(item, value),
               getFileType(findFile(item, value)?.[0]?.fileUrl),
               elementWidth,
               elementHeight,
               item,
               value,
            )}
         </div>
         <div className="custom-slide-item-container__content-container">
            <div>
               <h6 className="main-title">{itemTitle}</h6>
            </div>
         </div>
      </div>
   );
};

export { ThreeItems, OneBigItem, ThreeItemsMultipleDataType };
